import { useEffect, useState } from 'react';
export const useObservable = (observable, initialState) => {
    const [state, setState] = useState(initialState);
    useEffect(() => {
        const sub = observable.subscribe(setState);
        return () => sub.unsubscribe();
    }, [observable]);
    return state;
};
export default useObservable;
